<div class="flex items-center justify-between bg-surface-800 appContainer !py-2 min-h-[56px]">
  <div class="flex items-center gap-x-4">
    <img src="assets/mars-logo.svg" alt="M.A.R.S">
  </div>
</div>